"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedLayout = void 0;
var React = require("react");
var BaseLayout_1 = require("./BaseLayout");
var index_1 = require("../../index");
var PaginatedLayout = /** @class */ (function (_super) {
    __extends(PaginatedLayout, _super);
    function PaginatedLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            widgets: _this.props.widgets,
            currentWidgets: [],
            currentPage: 0,
            totalPages: 1,
            hasNextPage: false,
            hasPreviousPage: false
        };
        return _this;
    }
    PaginatedLayout.prototype.componentDidMount = function () {
        this.paginate(this.state.currentPage);
    };
    /**
     * Renders the widget
     */
    PaginatedLayout.prototype.renderLayout = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "widgets-list" }, this.state.currentWidgets.map(function (widget) {
                return _super.prototype.renderWidget.call(_this, widget);
            })),
            this.renderPagination()));
    };
    /**
     * Calculates widgets to show in current page
     * @param currentPage
     */
    PaginatedLayout.prototype.paginate = function (currentPage) {
        var itemsPerPage = this.props.itemsPerPage !== undefined ? this.props.itemsPerPage : 10;
        var from = itemsPerPage * currentPage;
        var to = from + itemsPerPage;
        var currentWidgets = this.state.widgets.slice(from, to);
        var totalPages = Math.ceil(this.state.widgets.length / itemsPerPage);
        this.setState({
            currentWidgets: currentWidgets,
            totalPages: totalPages,
            currentPage: currentPage,
            hasPreviousPage: currentPage > 0,
            hasNextPage: currentPage < totalPages - 1
        });
    };
    /**
     * Calculates page numbers
     */
    PaginatedLayout.prototype.getPages = function () {
        var pages = [];
        for (var a = 0; a < this.state.totalPages; a++) {
            pages.push(a);
        }
        return pages;
    };
    /**
     * Renders pagination for the widgets
     */
    PaginatedLayout.prototype.renderPagination = function () {
        var _this = this;
        if (this.state.totalPages <= 1) {
            return "";
        }
        else {
            return (React.createElement(index_1.Pagination, null,
                React.createElement(index_1.PaginationItem, { disabled: !this.state.hasPreviousPage },
                    React.createElement(index_1.PaginationLink, { previous: true, href: "javascript:void(0)", onClick: this.paginate.bind(this, this.state.currentPage - 1) })),
                this.getPages().map(function (x) {
                    return React.createElement(index_1.PaginationItem, { active: x === _this.state.currentPage, key: x },
                        React.createElement(index_1.PaginationLink, { href: "javascript:void(0)", onClick: _this.paginate.bind(_this, x) }, x + 1));
                }),
                React.createElement(index_1.PaginationItem, { disabled: !this.state.hasNextPage },
                    React.createElement(index_1.PaginationLink, { next: true, href: "javascript:void(0)", onClick: this.paginate.bind(this, this.state.currentPage + 1) }))));
        }
    };
    return PaginatedLayout;
}(BaseLayout_1.BaseLayout));
exports.PaginatedLayout = PaginatedLayout;
//# sourceMappingURL=PaginatedLayout.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/widgets/layouts/PaginatedLayout.js
// module id = 2268
// module chunks = 0